import React, { useState } from "react";
import { StatusWarning } from "grommet-icons";
import Popover from "react-popover";
import { useTranslation } from "react-i18next";

// Shown next to a guest's name when their phone (or email) has been
// flagged as unreachable in the unreachableContacts collection.
export default function SmsUnreachableIcon({
  pkey,
  reason,
  phone,
  size = "small",
  color = "status-critical",
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const body =
    reason ||
    t("comms.smsUnreachableIcon", {
      phone: phone || t("comms.bannerThisNumber"),
    });
  return (
    <Popover
      key={pkey}
      isOpen={open}
      body={body}
      children={
        <div
          key={pkey}
          onMouseOver={() => setOpen(true)}
          onMouseOut={() => setOpen(false)}
          style={{ display: "inline-flex", alignItems: "center" }}
        >
          <StatusWarning size={size} color={color} />
        </div>
      }
    />
  );
}
